export const RESOURCE_LOCATION = {
    PROCESSFLOW: "processflow",
    PROCESSFLOW_STEP: "processflow_step",
    OBJECTIVE: "objective",
    OBJECTIVE_TARGET: "objective_target",
    ALERT: "alert",
    PROJECT: "project",
    PROJECT_PROCESS: "project_process",
    PROJECT_GAP: "project_gap",
    PROJECT_DASHBOARD: "project_dashboard",
    PROJECT_DASHBOARD_METRIC: "project_dashboard_metric",
    PROJECT_DASHBOARD_TEMPLATE: "project_dashboard_template",
    PROJECT_STAKEHOLDER: "project_stakeholder",
    DATASOURCE: "datasource",
    DATASERVICE: "dataservice",
    DASHBOARD: "dashboard",
    KNOWLEDGE_ARTICLE: "knowledge_article",
    KNOWLEDGE_CATEGORY: "knowledge_category",
    USER: "user",
} as const;

export type ResourceLocation = typeof RESOURCE_LOCATION[keyof typeof RESOURCE_LOCATION];

/** @deprecated Use RESOURCE_LOCATION */
export const TASK_LOCATION = RESOURCE_LOCATION;

export type TaskLocation = ResourceLocation;
